<template>
  <nav-bar title="新建监管企业" />
  <Content bottom="0">
    <van-form class="form" ref="form" @submit="handleSubmit">
      <Picker
        label="客户类型"
        :require="true"
        :columns="columns"
        @confirm-values="selected"
      />
      <Field
        name="creditNo"
        v-if="userType !== '04' && userType !== '05'"
        label="客户代码"
        @on-blur="onBlur"
        :require="true"
        :disabled="disabledNum"
      />
      <Field
        name="companyName"
        label="客户名"
        :require="true"
        :disabled="disabled"
        :defaultValue="cuMess.companyName"
      />
      <Field
        name="userName"
        label="联系人"
        :require="true"
        :disabled="disabled"
        :defaultValue="cuMess.userName"
      />
      <Field
        name="phoneNum"
        label="联系电话"
        :require="true"
        :disabled="disabled && userType !== '04' && userType !== '05'"
        :defaultValue="cuMess.phoneNum"
        @on-blur="onBlurPhone"
      />
      <Field
        name="street"
        label="街道"
        :defaultValue="street"
        :disabled="true"
      />
      <!-- <Picker
        label="街道"
        pickerType="cascader"
        @confirm-values="value => (street = value)"
      /> -->
      <Field
        name="address"
        label="地址"
        :require="true"
        :disabled="disabled"
        :defaultValue="cuMess.address"
      />
      <Field
        name="oldSupplyName"
        label="供应商"
        :disabled="disabled"
        :defaultValue="cuMess.oldSupply"
        v-if="disabled"
      />
      <Picker
        label="供应商"
        :columns="companyList"
        text="name"
        @confirm-values="getSupply"
        v-else
      />
      <Field
        name="oldSupply"
        label="供应商名称"
        v-if="showSupplyName && !disabled"
      />
      <Field
        name="illegalWeight"
        type="number"
        label="日用量"
        :disabled="disabled"
        :defaultValue="cuMess.illegalWeight"
      />
      <Field
        v-if="disabled"
        label="位置"
        :disabled="disabled"
        :defaultValue="
          cuMess.longitude ? `${cuMess.longitude},${cuMess.latitude}` : ''
        "
      />
      <SelectPoint v-else @get-value="selectPoint" :disabled="disabled" />
      <van-field v-if="status !== '1' && status !== ''" name="accordFlag" label="信息是否相符">
        <template #input>
          <van-radio-group v-model="checked" direction="horizontal">
            <van-radio name="0">不相符</van-radio>
            <van-radio name="1">相符</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <Picker
        label="合同开始时间"
        pickerType="time"
        :disabled="disabled"
        :defaultVal="contractSdate"
        @confirm-values="val => contractSdate = val"
      />
      <Picker
        label="合同结束时间"
        pickerType="time"
        :maxDate="afterYear(5)"
        :disabled="disabled"
        :defaultVal="contractEdate"
        @confirm-values="val => contractEdate = val"
      />
      <Field
        name="handlerName"
        label="经办人"
        :require="true"
        :disabled="disabled"
        :defaultValue="cuMess.handlerName"
      />
      <Field
        name="handlerTel"
        label="经办人电话"
        :require="true"
        :disabled="disabled"
        :defaultValue="cuMess.handlerTel"
      />
      <van-field
        v-if="checked === '0'"
        name="accordRemark"
        v-model="accordRemark"
        rows="2"
        autosize
        label="备注"
        type="textarea"
        placeholder="请输入备注"
      />
      <van-field name="uploader" label="合同" >
        <template #input>
          <van-uploader  v-model="fileList" :after-read="afterRead" :show-upload="showUpload"  />
        </template>
      </van-field>
      <div class="btn-container">
        <van-button
          block
          type="primary"
          native-type="submit"
          :loading="loading"
          :disabled="loading"
        >
          确认提交
        </van-button>
      </div>
    </van-form>
  </Content>
</template>

<script>
import { Toast, Notify } from 'vant'
import SelectPoint from './SelectPoint.vue'
import {
  queryCustomerInfoMess,
  getCompanyList,
  confirmCustomer,
  addManageUser
} from '@/api/superviseHome'
import {
  getMessListById
} from '@/api/customer'
import { useGetData } from '@/hooks/useGetData'
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import {
  useSubmit,
  loading
} from '@/hooks/useSubmit'
import { useRouter } from 'vue-router'
import getImgFile from '@/utils/getImgFile'
import { afterYear } from '@/utils/common'
export default {
  name: 'NewEnterprise',
  components: { SelectPoint },
  setup() {
    const disabledNum = ref(true)
    // 文件上传
    const fileList = ref([])
    const showUpload = ref(true)
    const imgPath = computed(() => {
      const arr = []
      fileList.value.forEach(item => {
        if (item.status === 'done') {
          arr.push(item.content)
        }
      })
      return arr
    })
    const afterRead = (file) => {
      getImgFile(file, fileList, showUpload)
    }
    const userType = ref('')
    const contractSdate = ref('')
    const contractEdate = ref('')
    // 选择位置
    const point = ref('') // 位置
    const selectPoint = value => {
      point.value = value
    }

    // 查询code
    const store = useStore()
    const street = computed(() => store.state.roleInfo.companyName)
    const tenantId = computed(() => store.state.roleInfo.tenantId)
    const form = ref(null)
    const disabled = ref(true)
    const status = ref('')
    // const diaMess = ref('')
    const cuMess = ref({})
    const onBlurPhone = (phone) => {
      if (userType.value === '04' || userType.value === '05') {
        form.value
          .validate('phoneNum')
          .then(res => {
            Toast.loading({
              duration: 0, // 持续展示 toast
              forbidClick: true,
              overlay: true,
              message: '验证信息...'
            })
            useGetData(
              queryCustomerInfoMess,
              data => {
                Toast.clear()

                Notify({ type: 'primary', message: data.diaMess })
                status.value = data.status
                cuMess.value = data.cuMess
                if (data.status === '1') {
                  disabled.value = false
                } else {
                  disabled.value = true
                }
              },
              () => {
                Toast.clear()
              }
            )({ creditNo: phone.value, typeCode: userType.value })
          })
          .catch(() => {
          })
      }
    }
    const onBlur = code => {
      form.value
        .validate('creditNo')
        .then(res => {
          Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            overlay: true,
            message: '验证信息...'
          })
          useGetData(
            queryCustomerInfoMess,
            data => {
              Toast.clear()
              Notify({ type: 'primary', message: data.diaMess })
              status.value = data.status
              if (data.status === '1') {
                disabled.value = false
              } else {
                cuMess.value = data.cuMess
                contractSdate.value = data.cuMess.contractSdate.substr(0, 10)
                contractEdate.value = data.cuMess.contractEdate.substr(0, 10)
                disabled.value = true
              }
            },
            () => {
              Toast.clear()
            }
          )({ creditNo: code.value, typeCode: userType.value })
        })
        .catch(() => {})
    }

    // 查询供应商
    const showSupplyName = ref(false)
    const comFlag = ref('')
    const companyId = ref('')
    const getSupply = value => {
      companyId.value = value.id
      comFlag.value = value.comFlag
    }
    watch(companyId, (val) => {
      val === '-1000' ? showSupplyName.value = true : showSupplyName.value = false
    })
    const companyList = ref([])
    useGetData(getCompanyList, data => {
      companyList.value = data
    })({ tenantId: tenantId.value || '' })
    // 提交
    const accordRemark = ref('')
    const checked = ref('')
    const router = useRouter()
    const handleSubmit = value => {
      const params1 = {
        insertUserid: computed(() => store.state.userInfo.id).value,
        userId: '',
        stCode: computed(() => store.state.roleInfo.companyId).value,
        accordRemark: accordRemark.value,
        accordFlag: checked.value,
        imgList: imgPath.value
      }
      const params2 = {
        ...value,
        companyId: companyId.value === '-1000' ? '' : companyId.value,
        userType: userType.value,
        streetCode: computed(() => store.state.roleInfo.companyId).value,
        insertUserid: computed(() => store.state.userInfo.id).value,
        longitude: point.value ? point.value[1] : 0.0,
        latitude: point.value ? point.value[0] : 0.0,
        imgList: imgPath.value,
        comFlag: comFlag.value,
        contractSdate: contractSdate.value,
        contractEdate: contractEdate.value,
        tenantId: tenantId.value || ''
      }
      if (status.value !== '1') {
        params1.userId = cuMess.value.userId
        const { onSubmit } = useSubmit(confirmCustomer, params1, data => {
          router.back()
        })
        onSubmit()
      } else {
        // params2.oldSupply = oldSupply.value
        const { onSubmit } = useSubmit(addManageUser, params2, data => {
          router.back()
        })
        onSubmit()
      }
    }
    // LIST
    const columns = ref()
    useGetData(getMessListById, data => {
      columns.value = data
    })()

    const selected = val => {
      userType.value = val.dicVal
      disabledNum.value = false
      cuMess.value = {}
      if (val.dicVal === '04' || val.dicVal === '05') {
        disabled.value = false
      }
    }

    return {
      handleSubmit,
      street,
      selectPoint,
      onBlur,
      disabled,
      form,
      status,
      cuMess,
      companyList,
      companyId,
      loading,
      columns,
      selected,
      imgPath,
      afterRead,
      fileList,
      showSupplyName,
      userType,
      checked,
      accordRemark,
      disabledNum,
      onBlurPhone,
      showUpload,
      getSupply,
      contractSdate,
      contractEdate,
      afterYear,
      tenantId
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-container {
  margin: 16px;
}
</style>
